import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close_white.svg'


const _withScopeId = n => (_pushScopeId("data-v-130be8c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = {
  key: 1,
  class: "modal"
}
const _hoisted_3 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  alt: "close",
  src: _imports_0
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "invalid-password-wrapper" }
const _hoisted_11 = { class: "modal-buttons" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.showModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t("PASSWORD_MODAL.TITLE")), 1),
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                  }, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("PASSWORD_MODAL.NEW")) + " ", 1),
                      _hoisted_8,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPassword) = $event)),
                        type: "password"
                      }, null, 512), [
                        [_vModelText, _ctx.newPassword]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("PASSWORD_MODAL.CONFIRM")) + " ", 1),
                      _hoisted_9,
                      _withDirectives(_createElementVNode("input", {
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.invalidPasswords())),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                        type: "password",
                        autocomplete: "off"
                      }, null, 544), [
                        [_vModelText, _ctx.confirmPassword]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("p", { class: "password-error-paragaph" }, _toDisplayString(_ctx.errorMessage), 513), [
                      [_vShow, _ctx.error]
                    ]),
                    _withDirectives(_createElementVNode("p", { class: "password-error-paragaph" }, _toDisplayString(_ctx.mismatchMessage), 513), [
                      [_vShow, _ctx.mismatchError]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      class: "btn primary",
                      disabled: _ctx.invalidPasswords(),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetPassword()))
                    }, _toDisplayString(_ctx.$t("PASSWORD_MODAL.SET")), 9, _hoisted_12)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}